import { LIST_PRODUCTS_TYPE } from '../../../../../types/orders';
import './ProductsListingTableHeader.scss';

interface IProductsListingTableHeaderProps {
  listProductsType: LIST_PRODUCTS_TYPE;
}

/**
 * Componente para el header de la tabla de productos
 */
const ProductsListingTableHeader = ({ listProductsType }: IProductsListingTableHeaderProps) => {
  const isStockBord = listProductsType === LIST_PRODUCTS_TYPE.STOCK_BORD;
  const hasBulkSelectionColumn = listProductsType === LIST_PRODUCTS_TYPE.CLIENTS;

  return (
    <div className={`productsListingTableHeader ${isStockBord ? 'stockBord' : ''}`}>
      {hasBulkSelectionColumn && <div className="tableField bulkSelection" aria-hidden />}
      <div className="tableField serial">Serial</div>
      <div className="tableField customer">Cliente</div>
      <div className="tableField sku">SKU</div>
      <div className="tableField name">Modelo</div>
      <div className="tableField pills">Características</div>
      <div className="tableField condition">Condición</div>
      <div className="tableField location">Ubicación actual</div>
      {isStockBord && <div className="tableField stockStatus">Estado de Stock</div>}
      <div className="tableField referenceModel">Tipo</div>
      <div className="tableField actions">Acciones</div>
    </div>
  );
};

export default ProductsListingTableHeader;
